export default "__VITE_ASSET__xie24e$1__"